import React, {FC, useEffect, useState} from 'react';

type DelayedMessageProps = {
	delay: number;
	text: string;
};

export const DelayedMessage: FC<DelayedMessageProps> = ({delay, text}) => {
	// Component variables
	const [message, setMessage] = useState('');

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setMessage(text);
		}, delay);

		return () => clearTimeout(timeoutId);
	}, []);

	return <>{message}</>;
};
